// extracted by mini-css-extract-plugin
export default {"noAccessBox":"NoAccess_noAccessBox__ZnLN3"};